export const API_EXTERNAL_ENDPOINT =
  'cottage-reviews/province/:province_slug/summary'

export const API_INTERNAL_ENDPOINT =
  'rurality/v3/cottage-reviews/province/summary'
